// extracted by mini-css-extract-plugin
export default {"customSelect":"customSelect_customSelect__dn1LU"};